// src/admin/shell/Topbar.tsx
// Slim top bar — keeps a search trigger (so power users can stay on the right
// hand side of the screen) and a notifications bell. The user identity / sign
// out moved to the Sidebar's user card. The ⌘K shortcut handler lives in
// AppShell so the sidebar entry shares the same modal.
import { Search, Bell } from 'lucide-react';
import styles from './Topbar.module.css';

interface Props {
  onSearchClick: () => void;
}

export default function Topbar({ onSearchClick }: Props) {
  return (
    <header className={styles.topbar}>
      <button type="button" className={styles.searchBtn} onClick={onSearchClick}>
        <Search size={14} />
        <span>Search borrowers, loans…</span>
        <kbd>⌘K</kbd>
      </button>
      <div className={styles.right}>
        <button type="button" className={styles.bell} aria-label="Notifications">
          <Bell size={16} />
          <span className={styles.bellDot} aria-hidden="true" />
        </button>
      </div>
    </header>
  );
}
